// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynamic-previous-countries-table {
  margin-bottom: 20px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 12px 0;
  border-bottom: 2px solid #e9ecef;
}

.table-header h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.add-btn {
  background: #28a745;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.2);
}

.add-btn:hover {
  background: #218838;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
}

.add-btn.secondary {
  background: #6c757d;
  box-shadow: 0 2px 4px rgba(108, 117, 125, 0.2);
}

.add-btn.secondary:hover {
  background: #5a6268;
  box-shadow: 0 4px 8px rgba(108, 117, 125, 0.3);
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  border: 2px dashed #e9ecef;
  border-radius: 12px;
  background: #f8f9fa;
}

.empty-state p {
  margin: 0 0 20px 0;
  color: #666;
  font-size: 16px;
}

/* Card-based Layout */
.entries-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.entry-card {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.entry-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border-color: #007bff;
}

.entry-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f1f3f4;
}

.form-row {
  display: grid;
  gap: 16px;
  margin-bottom: 16px;
}

.form-row-1 {
  grid-template-columns: 2fr 1.5fr 1fr !important;
}

.form-row-2 {
  grid-template-columns: 1fr 1fr;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  background: #f8f9fa;
  padding: 14px 16px;
  border-radius: 8px;
}

.field-group label {
  font-size: 14px;
  font-weight: 500;
  color: #495057;
  margin-bottom: 6px;
  min-height: 20px;
  white-space: nowrap;
  overflow: visible;
}

.field-group input {
  padding: 10px 14px;
  font-size: 15px;
  min-height: 42px;
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  transition: all 0.2s ease;
  box-sizing: border-box;
  background: white;
}

.field-group input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.entry-form {
  width: 100%;
}

.entry-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: #007bff;
  color: white;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 600;
  margin-right: 8px;
}

.entry-number {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #495057;
}

.entry-number h5 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.remove-btn {
  background: #dc3545;
  color: white;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  padding: 0;
}

.remove-btn:hover {
  background: #c82333;
  transform: scale(1.1);
}

.table-footer {
  padding: 16px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/DynamicPreviousCountriesTable.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB","sourcesContent":[".dynamic-previous-countries-table {\n  margin-bottom: 20px;\n}\n\n.table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  padding: 12px 0;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.table-header h4 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n}\n\n.add-btn {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.2);\n}\n\n.add-btn:hover {\n  background: #218838;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);\n}\n\n.add-btn.secondary {\n  background: #6c757d;\n  box-shadow: 0 2px 4px rgba(108, 117, 125, 0.2);\n}\n\n.add-btn.secondary:hover {\n  background: #5a6268;\n  box-shadow: 0 4px 8px rgba(108, 117, 125, 0.3);\n}\n\n.empty-state {\n  text-align: center;\n  padding: 40px 20px;\n  border: 2px dashed #e9ecef;\n  border-radius: 12px;\n  background: #f8f9fa;\n}\n\n.empty-state p {\n  margin: 0 0 20px 0;\n  color: #666;\n  font-size: 16px;\n}\n\n/* Card-based Layout */\n.entries-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.entry-card {\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 24px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease;\n}\n\n.entry-card:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  border-color: #007bff;\n}\n\n.entry-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #f1f3f4;\n}\n\n.form-row {\n  display: grid;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.form-row-1 {\n  grid-template-columns: 2fr 1.5fr 1fr !important;\n}\n\n.form-row-2 {\n  grid-template-columns: 1fr 1fr;\n}\n\n.field-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n  background: #f8f9fa;\n  padding: 14px 16px;\n  border-radius: 8px;\n}\n\n.field-group label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #495057;\n  margin-bottom: 6px;\n  min-height: 20px;\n  white-space: nowrap;\n  overflow: visible;\n}\n\n.field-group input {\n  padding: 10px 14px;\n  font-size: 15px;\n  min-height: 42px;\n  width: 100%;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n  background: white;\n}\n\n.field-group input:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n.entry-form {\n  width: 100%;\n}\n\n.entry-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  background: #007bff;\n  color: white;\n  border-radius: 50%;\n  font-size: 14px;\n  font-weight: 600;\n  margin-right: 8px;\n}\n\n.entry-number {\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  font-weight: 600;\n  color: #495057;\n}\n\n.entry-number h5 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.remove-btn {\n  background: #dc3545;\n  color: white;\n  border: none;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 20px;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  padding: 0;\n}\n\n.remove-btn:hover {\n  background: #c82333;\n  transform: scale(1.1);\n}\n\n.table-footer {\n  padding: 16px;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
